import classNames from "classnames";

export function LiveGameExtraEco({ fishingShips, traders, leftSide }) {
    return (
        <div className={classNames("flex items-center justify-center", leftSide ? "flex-row" : "flex-row-reverse")}>
            {fishingShips > 0 && (
                <>
                    <img className="w-6 h-6 mt-[14px]" src="/liveGameIcons/fishing_boat.png" alt="" />
                    <p className="text-[#b1b1b1] text-xl">{fishingShips}</p>
                </>
            )}
            {traders > 0 && (
                <>
                    <img className="w-6 h-6 mt-[14px]" src="/liveGameIcons/trade_cart.png" alt="" />
                    <p className="text-[#b1b1b1] text-xl">{traders}</p>
                </>
            )}
        </div>
    )
}